export const getInputTokens = (tokens) => {
    return {
        label: tokens.component.label,
        formField: tokens.component.formField,
        input: tokens.component.input,
        placeholder: tokens.component.placeholder,
        color: tokens.semantic.color,
        spacing: tokens.semantic.spacing,
        borderWidth: tokens.semantic.borderWidth,
        shadow: tokens.semantic.shadow,
        semantic: tokens.semantic,
    };
};
const input = (tokens) => {
    const { input, placeholder, shadow, spacing, label, formField, semantic } = getInputTokens(tokens);
    let shouldNormalizePlaceholder = false;
    if (typeof window !== "undefined") {
        shouldNormalizePlaceholder =
            document.documentElement.lang === "zh" || document.documentElement.lang === "ja";
    }
    return {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    borderRadius: input.borderRadius.value,
                    gap: spacing.none.value,
                    paddingLeft: input.paddingHorizontal.value,
                    paddingRight: input.paddingHorizontal.value,
                    "&.Mui-focused": {
                        boxShadow: shadow.focus.value.stringValue,
                    },
                    "> .MuiIconButton-root": {
                        padding: spacing.xs.value,
                        flexShrink: 0,
                    },
                    "> .MuiIconButton-root, > svg": {
                        flexShrink: 0,
                    },
                    "> .MuiIconButton-root svg, > svg": {
                        width: input.icon.width.value,
                        height: input.icon.height.value,
                        color: input.icon.color.value,
                    },
                },
                input: ({ ownerState }) => (Object.assign({ color: input.color.value, "&::placeholder": {
                        color: placeholder.color.value,
                        fontStyle: shouldNormalizePlaceholder ? "normal" : placeholder.fontStyle.value,
                        opacity: 1,
                    } }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.disabled) && {
                    color: input.disabled.color.value,
                }))),
                inputAdornedStart: {
                    "&&": {
                        margin: spacing.none.value,
                        paddingLeft: input.gap.value,
                    },
                },
                inputAdornedEnd: {
                    "&&": {
                        margin: spacing.none.value,
                        paddingRight: input.gap.value,
                    },
                },
                adornedStart: {
                    // When start adornments are not wrapped in `<InputAdornment />`
                    "&&": {
                        "& > .MuiIconButton-root:first-of-type": {
                            marginLeft: `-${input.gap.value}`,
                        },
                        "& > svg:first-of-type": {
                            marginRight: input.gap.value,
                        },
                    },
                },
                adornedEnd: {
                    // When end adornments are not wrapped in `<InputAdornment />`
                    "&&": {
                        "& > input ~ .MuiIconButton-root:last-of-type": {
                            marginRight: `-${input.gap.value}`,
                        },
                        // add extra spacing between the input and the first icon following it
                        "& > input ~ svg:first-of-type": {
                            marginLeft: input.gap.value,
                        },
                    },
                },
                multiline: {
                    "&&": {
                        padding: spacing.none.value,
                    },
                },
                inputMultiline: ({ ownerState }) => ({
                    lineHeight: input.lineHeight.value,
                    "&&&": Object.assign({ paddingLeft: input.paddingHorizontal.value, paddingRight: input.paddingHorizontal.value, paddingTop: input.paddingVertical.value, paddingBottom: input.paddingVertical.value }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large" && {
                        paddingTop: input.large.paddingVertical.value,
                        paddingBottom: input.large.paddingVertical.value,
                    })),
                }),
            },
        },
        MuiOutlinedInput: {
            // remove white space from outline after label animation is disabled
            defaultProps: {
                notched: false,
            },
            styleOverrides: {
                input: ({ ownerState }) => (Object.assign({ paddingLeft: spacing.none.value, paddingRight: spacing.none.value, paddingTop: input.paddingVertical.value, paddingBottom: input.paddingVertical.value, minHeight: parseInt(input.height.value) - 2 * parseInt(input.paddingVertical.value) }, (!(ownerState === null || ownerState === void 0 ? void 0 : ownerState.multiline) && Object.assign({}, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.size) === "large" && {
                    minHeight: parseInt(input.large.height.value) -
                        2 * parseInt(input.large.paddingVertical.value),
                    paddingTop: input.large.paddingVertical.value,
                    paddingBottom: input.large.paddingVertical.value,
                    // center the selected text without using flex
                    "&.MuiSelect-outlined": {
                        paddingTop: parseInt(input.large.paddingVertical.value) + 2,
                        paddingBottom: parseInt(input.large.paddingVertical.value) + 2,
                    },
                }))))),
                root: ({ ownerState }) => (Object.assign({ paddingLeft: input.paddingHorizontal.value, paddingRight: input.paddingHorizontal.value, backgroundColor: input.backgroundColor.value, ".MuiSelect-icon, .MuiNativeSelect-icon": Object.assign(Object.assign({ height: input.icon.height.value, width: input.icon.width.value, fontSize: input.icon.width.value, right: input.paddingHorizontal.value, color: input.color.value }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.disabled) && {
                        color: input.disabled.icon.color.value,
                    })), { "& svg": {
                            color: "inherit",
                        } }), ":hover": {
                        ".MuiOutlinedInput-notchedOutline": {
                            borderColor: input.hover.borderColor.value,
                        },
                    }, "&.Mui-disabled": {
                        ".MuiOutlinedInput-notchedOutline": {
                            borderColor: input.disabled.borderColor.value,
                        },
                        ".MuiInputAdornment-root": {
                            color: input.disabled.icon.color.value,
                            svg: {
                                color: input.disabled.icon.color.value,
                            },
                        },
                    }, "&.Mui-focused": {
                        ".MuiOutlinedInput-notchedOutline": {
                            borderWidth: input.borderWidth.value,
                            borderColor: input.active.borderColor.value,
                        },
                    } }, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.readOnly) && {
                    backgroundColor: input.readonly.backgroundColor.value,
                    borderColor: input.disabled.borderColor.value,
                    ".MuiButtonBase-root.MuiIconButton-root": {
                        svg: {
                            color: input.disabled.borderColor.value,
                        },
                    },
                }))),
                notchedOutline: {
                    top: 0,
                    borderWidth: input.borderWidth.value,
                    borderColor: input.borderColor.value,
                    paddingLeft: input.paddingHorizontal.value,
                    paddingRight: input.paddingHorizontal.value,
                    legend: {
                        height: 0,
                    },
                },
            },
        },
        MuiInputLabel: {
            defaultProps: {
                shrink: true,
            },
            styleOverrides: {
                root: {
                    // remove default label animation
                    position: "relative",
                    transform: "none",
                    color: "inherit",
                    fontSize: label.formField.fontSize.value,
                    lineHeight: label.formField.lineHeight.value,
                    marginBottom: formField.label.gap.value,
                },
            },
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    display: "flex",
                    color: input.prefix.color.value,
                    fontSize: input.prefix.fontSize.value,
                    lineHeight: input.prefix.lineHeight.value,
                    flexShrink: 0,
                    margin: spacing.none.value,
                    ".MuiIconButton-root": {
                        padding: spacing.xs.value,
                        color: input.icon.color.value,
                        height: parseInt(input.icon.width.value) + parseInt(spacing.xs.value),
                        width: parseInt(input.icon.width.value) + parseInt(spacing.xs.value),
                        margin: spacing.none.value,
                        "& + .MuiIconButton-root": {
                            marginLeft: parseInt(spacing.lg.value) - parseInt(spacing.xs.value),
                        },
                    },
                    ".MuiTypography-root": {
                        color: "inherit",
                    },
                    svg: {
                        color: input.icon.color.value,
                    },
                    ".MuiAvatar-root, svg": {
                        width: input.icon.width.value,
                        height: input.icon.height.value,
                        fontSize: semantic.fontSize.text.md.value,
                        flexShrink: 0,
                    },
                },
                positionStart: {
                    ".MuiIconButton-root:first-of-type": {
                        marginLeft: "-1px",
                    },
                    "> .MuiIconButton-root:last-of-type, > svg:last-of-type": {
                        marginRight: input.gap.value,
                    },
                },
                positionEnd: {
                    ".MuiIconButton-root:last-of-type": {
                        marginRight: "-1px",
                    },
                    "> .MuiIconButton-root:first-of-type, > svg:first-of-type": {
                        marginLeft: input.gap.value,
                    },
                },
            },
        },
    };
};
export default input;
//# sourceMappingURL=inputBase.js.map